import type { TFunction } from 'i18next';
import type { IndiaGstSplit } from '@unipostudio/platform-constants';
import { formatMoney } from '@/shared/lib/intl';

/**
 * A formatted price with the tax note its currency needs: rupee prices
 * include 18% GST (ADR-007), so the price shown before paying says so. Other
 * currencies are returned as they are: Paddle adds VAT or sales tax at
 * checkout.
 */
export function withTaxNote(formatted: string, currency: string | null | undefined, t: TFunction): string {
  return currency === 'INR' ? `${formatted} ${t('settings.billingTab.inclGst')}` : formatted;
}

/** The GST inside a rupee price, as "₹846.61 + ₹152.39 GST" (indiaGstSplit). */
export function formatGstSplit(split: IndiaGstSplit, t: TFunction): string {
  const rupees = (amount: number): string => formatMoney(amount, 'INR');
  return t('settings.billingTab.gstSplit', { base: rupees(split.base), gst: rupees(split.gst) });
}
